<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="9.393" height="5" viewBox="0 0 9.393 5">
    <path d="M4.5,0,9,5H0Z" transform="translate(9.393 5) rotate(180)" />
  </svg>
</template>
